'use strict';

// Interceptor added in to medApp (see med_app.js) to add our token to every request
// Also forces a refresh of the auth token every five minutes
medApp.factory('AuthTokenHttpInterceptor', ['$q', '$rootScope', '$location', '$document', '$cookieStore', '$injector', 'CoreLocationService', function($q, $rootScope, $location, $document, $cookieStore, $injector, CoreLocationService) {
    // Refresh the token 1 minute after the initial login/page refresh.
    var nextTokenRefresh = new Date().getTime() + 60000;
    return {
        getNextTokenRefresh: function() { return nextTokenRefresh; },
        setNextTokenRefresh: function(time) { nextTokenRefresh = time; },
        request: function(config) {
            if(config.url.indexOf('https://assets.meltwater.io') === 0) {
                // Ensure the Authorization header is not on the request, otherwise Firefox & Safari can't load the file
                delete config.headers.Authorization;
            } else if(config.headers.Authorization === undefined) {
                // Before making call, add Authorization header
                var company = $injector.get('company'); // Doing it like this to avoid a circular dependency error
                config.headers['Authorization'] = company.getAuthToken();
            }
            //Add x-client-name for requests to the identity service - otherwise they will get rejected
            if(config.url.indexOf('identity.meltwater.io') !== -1) {
                config.headers['x-client-name'] = 'sharable-dashboard-web'
            }
            return config || $q.when(config);
        },
        response: function(response) {
            var switchingCompanies = response.config.url.match(/\/switchCompany\//) !== null;

            // Successful response.  If we haven't refreshed the token in the last 5 minutes, do it now.
            var company = $injector.get('company'); // Doing it like this to avoid a circular dependency error
            if(!switchingCompanies && typeof company.getAuthToken() !== 'undefined' && new Date().getTime() > nextTokenRefresh) {
                nextTokenRefresh = new Date().getTime() + 300000;

                //centralized the resetToken code in the company, at least for now, since that seems to be where a lot of this logic is.
                company.resetTokenCookie();
            }
            return response || $q.when(response);
        },
        responseError: function(rejection) {
            if(rejection.status === undefined || rejection.status !== 401)
                return $q.reject(rejection);

            if(rejection.status === 401) {
                $injector.get('CoreUserService').logout(CoreLocationService.buildLogoutUrlWithRedirect());
            }
        }
    };
}]);
